"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConfig_1 = require("../BaseConfig");
const override = {
    env: "dev",
    ecs: Object.assign(Object.assign({}, BaseConfig_1.default.ecs), { host: "" }),
    urls: Object.assign(Object.assign({}, BaseConfig_1.default.urls), { absoluteUrls: Object.assign(Object.assign({}, BaseConfig_1.default.urls.absoluteUrls), { pstnCapabilities: "/pstn" }) }),
};
exports.default = Object.assign(Object.assign({}, BaseConfig_1.default), override);
